/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DoctorAssociation from './doctor-association';
import DoctorAssociationDetail from './doctor-association-detail';
import DoctorAssociationUpdate from './doctor-association-update';
import DoctorAssociationDeleteDialog from './doctor-association-delete-dialog';

const DoctorAssociationRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DoctorAssociation />} />
    <Route path="new" element={<DoctorAssociationUpdate />} />
    <Route path=":id">
      <Route index element={<DoctorAssociationDetail />} />
      <Route path="edit" element={<DoctorAssociationUpdate />} />
      <Route path="delete" element={<DoctorAssociationDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DoctorAssociationRoutes;
